// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1hZ48","item":"PaymentsMobile_item__ly0Tg","label":"PaymentsMobile_label__1anKO","amount":"PaymentsMobile_amount__ZutUy"};